import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { DashboardComponent } from '../app/dashboard/dashboard.component';
import { RegisterApplicationComponent } from '../app/register-application/register-application.component';
import { DetailsComponent } from './details/details.component';
import { LayoutComponent } from './layout/layout.component';
import { ErrorComponent } from './error/error.component';
import { AuditComponent } from '../app/audit/audit.component';
import { ApplicationLoginLogComponent } from './application-login-log/application-login-log.component';
import { ApplicationsComponent } from './applications/applications.component';



const routes: Routes = [

  { path: 'app', component: AppComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'layout', component: LayoutComponent,
     children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'applications', component: ApplicationsComponent },
      { path: 'details', component: DetailsComponent },
      { path: 'register', component: RegisterApplicationComponent },
      { path: 'audit', component: AuditComponent },
      { path: 'loginlog/:activeTab', component: ApplicationLoginLogComponent }] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
